export default "__VITE_ASSET__B$WUGZ4z__"